import { i as m } from "../index.es-XNBESE3P.js";
function s({ size: e, productId: a, hash: c }) {
  const i = m();
  if (!i)
    throw new Error("Client script settings are not yet available");
  return `https://${i.thumbnailHost}/${i.account}/${e}/${a}/${c}/A`;
}
function l({ size: e }) {
  function a(u, r) {
    if (r)
      return s({
        size: e,
        productId: u,
        hash: r
      });
  }
  function c(u, r) {
    if (r)
      return r.map((t) => ({
        ...t,
        imageUrl: a(u, t.imageHash) ?? t.imageUrl
      }));
  }
  function i(u, r, t) {
    if (!t)
      return r;
    if (r)
      return t.map(
        (n) => s({
          size: e,
          productId: u,
          hash: n
        })
      );
  }
  return function(r) {
    const t = r.productId;
    return t ? {
      ...r,
      imageUrl: a(t, r.imageHash) ?? r.imageUrl,
      thumbUrl: a(t, r.thumbHash) ?? r.thumbUrl,
      skus: c(t, r.skus),
      alternateImageUrls: i(t, r.alternateImageUrls, r.alternateImageHashes)
    } : r;
  };
}
const p = /cdn\.shopify\.com/, f = {
  1: "170x170",
  2: "100x100",
  3: "90x70",
  4: "50x50",
  5: "30x30",
  6: "100x140",
  7: "200x200",
  8: "400x400",
  9: "750x750"
};
function g(e) {
  return e in f;
}
function U({ size: e, fallback: a = (c) => c }) {
  if (e === "orig")
    return a;
  const c = f[e] || e;
  function i(n) {
    return n ? new URL(n).hostname.match(p) : !1;
  }
  function u(n) {
    return n ? i(n) ? n.replace(/(\.jpg|\.png|\.jpeg|\.gif|\.webp)/, `_${c}$1`) : n : "";
  }
  function r(n) {
    if (n)
      return n.map((o) => ({
        ...o,
        imageUrl: u(o.imageUrl)
      }));
  }
  function t(n) {
    if (n)
      return n.map((o) => u(o));
  }
  return function(o) {
    return i(o.imageUrl) ? {
      ...o,
      imageUrl: u(o.imageUrl),
      thumbUrl: u(o.thumbUrl),
      skus: r(o.skus),
      alternateImageUrls: t(o.alternateImageUrls)
    } : a(o);
  };
}
function d() {
  return window.Nosto?.shopifyScript;
}
function x({ size: e }) {
  const a = l({ size: e });
  return d() && g(e) ? U({ size: e, fallback: a }) : a;
}
export {
  s as generateThumbnailUrl,
  l as nostoThumbnailDecorator,
  U as shopifyThumbnailDecorator,
  x as thumbnailDecorator
};
